<template>
  <el-dialog
    :title="$t('merchantShop.editShop')"
    :visible.sync="dialogVisible"
    width="60%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      label-position="right"
    >
      <el-form-item :label="$t('merchantShop.shopType')" prop="shopType">
        <el-select
          v-model="form.shopType"
          :placeholder="$t('merchantShop.selectShopType')"
          style="width:100%"
        >
          <el-option
            v-for="item in shopTypes"
            :key="item.shopTypeId"
            :label="item.typeName"
            :value="item.shopTypeId"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('merchantShop.shopName')" prop="shopName">
        <el-input
          v-model="form.shopName"
          :placeholder="$t('merchantShop.inputShopName')"
        />
      </el-form-item>

      <el-form-item :label="$t('merchantShop.address')" prop="returnAddress">
        <el-input
          v-model="form.returnAddress"
          :placeholder="$t('merchantShop.inputAddress')"
        />
      </el-form-item>

      <el-form-item :label="$t('merchantShop.phone')" prop="returnLink">
        <el-input
          v-model="form.returnLink"
          :placeholder="$t('merchantShop.inputPhone')"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="_editMerchantShopInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateShop, getShopTypes } from '@/api/admin/merchantShopApi'

export default {
  name: 'EditMerchantShopInfo',
  data() {
    return {
      dialogVisible: false,
      form: {
        storeId: '',
        shopId: '',
        shopName: '',
        returnAddress: '',
        returnLink: '',
        shopType: ''
      },
      shopTypes: [],
      rules: {
        shopType: [
          { required: true, message: this.$t('merchantShop.selectShopType'), trigger: 'change' }
        ],
        shopName: [
          { required: true, message: this.$t('merchantShop.inputShopName'), trigger: 'blur' },
          { max: 200, message: this.$t('merchantShop.shopNameMaxLength'), trigger: 'blur' }
        ],
        returnAddress: [
          { required: true, message: this.$t('merchantShop.inputAddress'), trigger: 'blur' }
        ],
        returnLink: [
          { required: true, message: this.$t('merchantShop.inputPhone'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      Object.assign(this.form, params)
      this._listShopTypes()
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.form = {
        storeId: '',
        shopId: '',
        shopName: '',
        returnAddress: '',
        returnLink: '',
        shopType: ''
      }
    },
    async _editMerchantShopInfo() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        
        try {
          await updateShop(this.form)
          this.$emit('refresh')
          this.closeDialog()
          this.$message.success(this.$t('merchantShop.editSuccess'))
        } catch (error) {
          console.error('修改商铺失败:', error)
          this.$message.error(error.message || this.$t('merchantShop.editFailed'))
        }
      })
    },
    async _listShopTypes() {
      try {
        const res = await getShopTypes({ page: 1, row: 100 })
        this.shopTypes = res.data
      } catch (error) {
        console.error('获取商铺类型失败:', error)
      }
    }
  }
}
</script>